import { Button, Stack, Typography } from "@mui/material";
import useWaiverStore from "../../../stores/useWaiverStore";
import { useEffect } from "react";
import index from "../../../api/auth/waivers";
import WushPopover from "../../../components/layout/WushPopover";
import WaiverForm from "../../../components/form/waiver/WaiverForm";
import WaiverTable from "../../../components/displays/waivers/WaiverTable";
import destroy from "../../../api/auth/waivers/destroy";

export default function Waivers() {
  const { waivers, setWaivers, removeWaiver } = useWaiverStore();

  useEffect(() => {
    if(waivers.length === 0) {
      index((response) => {
        setWaivers(response);
      });
    }
  }, []);

  const handleDelete = (waiver) => {
    destroy(waiver.id, () => {
      removeWaiver(waiver);
    });
  };

  return (
    <Stack>
      <Stack mb={4}>
        <Typography variant="h4">Waivers</Typography>
        <Typography variant="body1">Add waivers that may be assigned to items for reservation completion</Typography>
      </Stack>
      <Stack mb={2}>
        <WushPopover
          anchor={
            <Button variant="contained" color="primary">
              Add Waiver
            </Button>
          }
        >
          <Stack p={2}>
            <WaiverForm />
          </Stack>
        </WushPopover>
      </Stack>
      <Stack>
        <WaiverTable waivers={waivers} handleDelete={handleDelete} />
      </Stack>
    </Stack>
  );
}